<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog work_assign_form"
        title="分配实施人员"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body" v-if="dialogVisible">
            <el-form
                ref="workOrderAssignForm"
                :model="workOrderAssignForm"
                :rules="workOrderAssignFormRules"
                label-position="top"
                size="small"
            >
                <div
                    v-for="(user, index) in workOrderAssignForm.processing_user"
                    :key="index"
                    class="work_assign_user_item"
                >
                    <div class="work_assign_user_item_title">
                        <span>实施明细</span>
                        <span
                            class="handle_icon_wrap"
                            v-show="workOrderAssignForm.processing_user.length > 1"
                            @click="handleClickRemoveUser(index)"
                            ><i class="iconfont icon-shanchu1"></i
                        ></span>
                    </div>
                    <div class="work_assign_user_item_content">
                        <el-form-item
                            label="分配实施人员"
                            :prop="`processing_user.${index}.processing_uids`"
                            :rules="workOrderAssignFormRules.processing_uids"
                        >
                            <el-select
                                v-model="user.processing_uids"
                                filterable
                                placeholder="请选择人员"
                                remote
                                multiple
                            >
                                <el-option
                                    v-for="item in getProcessingUserList()"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="实施开始时间"
                            :prop="`processing_user.${index}.plan_start_date`"
                            :rules="workOrderAssignFormRules.plan_start_date"
                        >
                            <div class="flex_wrap">
                                <el-date-picker
                                    v-model="user.plan_start_date"
                                    format="yyyy-MM-dd"
                                    placeholder="请选择时间"
                                    size="small"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                                <span class="line"></span>
                                <el-select v-model="user.plan_start_time">
                                    <el-option :value="1" label="上午"></el-option>
                                    <el-option :value="2" label="下午"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                        <el-form-item
                            label="实施结束时间"
                            :prop="`processing_user.${index}.plan_end_date`"
                            :rules="workOrderAssignFormRules.plan_end_date"
                        >
                            <div class="flex_wrap">
                                <el-date-picker
                                    v-model="user.plan_end_date"
                                    format="yyyy-MM-dd"
                                    placeholder="请选择时间"
                                    size="small"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                                <span class="line"></span>
                                <el-select v-model="user.plan_end_time">
                                    <el-option :value="1" label="上午"></el-option>
                                    <el-option :value="2" label="下午"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="work_assign_item_add" @click="handleClickAddUser">
                    <i class="iconfont icon-tianjia1"></i>
                    <span>添加更多</span>
                </div>
                <el-form-item label="说明" prop="assign_note">
                    <el-input
                        v-model="workOrderAssignForm.assign_note"
                        :rows="7"
                        maxlength="500"
                        placeholder="请输入"
                        show-word-limit
                        type="textarea"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { roleDetail, workOrderAssign } from "@/api";
export default {
    name: "WorkOrderAssign",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        // 已经选择过的实施人员
        processing_users_selected: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        // 自定义校验规则：结束时间不能早于开始时间
        const validateStartDate = (rule, value, callback) => {
            const index = rule.field.split('.')[1]; // 获取当前数组项的索引
            const plan_end_date = this.workOrderAssignForm.processing_user[index].plan_end_date;
            const plan_start_date = value;

            if (!plan_start_date) {
                callback(new Error('请选择实施开始时间'));
            } else if (plan_start_date && plan_end_date && (new Date(plan_start_date) > new Date(plan_end_date))) {
                callback(new Error('实施结束时间不能晚于实施开始时间'));
            } else {
                callback();
            }
        };
        const validateEndDate = (rule, value, callback) => {
            const index = rule.field.split('.')[1]; // 获取当前数组项的索引
            const plan_start_date = this.workOrderAssignForm.processing_user[index].plan_start_date;
            const plan_end_date = value;

            if (!plan_end_date) {
                callback(new Error('请选择实施结束时间'));
            } else if (plan_start_date && plan_end_date && (new Date(plan_end_date) < new Date(plan_start_date))) {
                callback(new Error('实施结束时间不能早于实施开始时间'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            workOrderAssignForm: {
                processing_user: [
                    {
                        processing_uids: "",
                        plan_start_date: "",
                        plan_start_time: 1,
                        plan_end_date: "",
                        plan_end_time: 1,
                    },
                ],
                assign_note: "",
            },
            workOrderAssignFormRules: {
                processing_uids: [{ required: true, message: "请选择", trigger: ["blur", "change"] }],
                plan_start_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }, { validator: validateStartDate, trigger: 'change' }],
                plan_end_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }, { validator: validateEndDate, trigger: 'change' }],
            },
            processingUserList: [],
            processingUserSelectedList: []
        };
    },
    created() {
        this.processingUserSelectedList = this.processing_users_selected.map(item=> {
            return item.processing_user
        })
        this.$nextTick(() => {
            this.getRoleDetail()
            this.$refs.workOrderAssignForm.clearValidate();
        });
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        getProcessingUserList() {
            const users = this.processingUserList || []
            const uids = this.workOrderAssignForm.processing_user.map(item=> item.processing_uids).flat()
            const list = users.filter(item=> !uids.includes(item.id))
            return list
        },
        // 添加
        handleClickAddUser() {
            this.workOrderAssignForm.processing_user.push({
                processing_uids: "",
                plan_start_date: "",
                plan_start_time: 1,
                plan_end_date: "",
                plan_end_time: 1,
            });
            this.$nextTick(() => {
                this.$refs.workOrderAssignForm.clearValidate();
            });
        },
        // 删除
        handleClickRemoveUser(index) {
            // if (this.workOrderAssignForm.processing_uids.length > 1) {
            //     this.workOrderAssignForm.processing_uids.splice(index, 1);
            // }
            this.workOrderAssignForm.processing_user.splice(index, 1);
        },
        // 获取在工单实施角色中设置的范围内选择人员
        getRoleDetail() {
            roleDetail({
                role_type: "processing_user"
            }).then(res=> {
                if(res.code === 200) {
                    const data = res.data || []
                    const selectedUids = this.processingUserSelectedList.map((item) => item.id);
                    // 从实施角色中的全部未被选择人员中选择，排除掉当前工单已经选择过的
                    const processingUserList = data.filter((item) => !selectedUids.includes(item.id));
                        this.processingUserList = processingUserList;
                }
            })
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderAssignForm.validate((valid) => {
                if (valid) {
                    if (!this.workorder_id) return;
                    const params = {
                        workorder_id: this.workorder_id,
                        processing_user: this.workOrderAssignForm.processing_user,
                        assign_note: this.workOrderAssignForm.assign_note,
                    };
                    // console.log(params);
                    workOrderAssign(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message || "分配成功");
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.work_assign_form {
    .work_assign_user_item {
        border: 1px solid rgba(237, 240, 244, 1);
        border-radius: 6px;
        margin-bottom: 16px;
        .work_assign_user_item_title {
            height: 38px;
            padding: 0 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: rgba(237, 240, 244, 1);
            span:nth-child(1) {
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }
        }
        .work_assign_user_item_content {
            padding: 12px 12px 0;
        }
    }
    .work_assign_item_add {
        cursor: pointer;
        width: 100%;
        height: 32px;
        border-radius: 4px;
        border: 1px dashed rgba(41, 144, 255, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(41, 144, 255, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        margin-bottom: 16px;
    }
    .flex_wrap {
        display: flex;
        align-items: center;
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        .el-input__inner {
            padding: 0 12px;
            border-color: rgb(217, 217, 217);
            border: none;
            color: rgb(51, 51, 51);
            font-size: 14px;
            padding-left: 30px !important;
        }
        .el-select {
            width: 60px !important;
            flex-shrink: 0;
            .el-input__inner {
                padding: 0 !important;
            }
        }
    }
}
</style>
